import { useTheme } from "@emotion/react";
import { Skeleton, useMediaQuery } from "@mui/material";

function ExercisesSkeleton() {
  const theme = useTheme();
  const matchesTablet = useMediaQuery(theme.breakpoints.down("tablet"));
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
      <Skeleton
        animation={"wave"}
        variant={"RectangleRounded"}
        width={
          matchesSm
            ? "calc(90vw - 50px)"
            : matchesTablet
            ? "calc(50vw - 50px)"
            : 210
        }
        height={matchesSm ? 180 : matchesTablet ? 180 : 260}
        sx={{ display: "flex", borderRadius: "8px" }}
      />
    </>
  );
}

export default ExercisesSkeleton;
